import React from "react";
import { CompanyServiceCard } from "./CompanyServiceCard";

export function CompanyServicePage() {
  return <CompanyServiceCard />;
}
